import { IActionUrlForm } from '../types/ActionUrl';
import { useQuery } from 'react-query';
import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { isNullOrUndefined } from '../../../../shared/validators/common';
import { QueryOptions, QueryResult } from '../../../../shared/types/query';
import { PAGE_KEY } from './index';

export function useGetActionUrlById(id?: string, options?: QueryOptions<IActionUrlForm>): QueryResult<IActionUrlForm> {
  const http = useHttpClient();

  return useQuery<IActionUrlForm>({
    ...options,
    queryKey: [`${PAGE_KEY}/get`, id],
    queryFn: async () => {
      return http.request({
        method: 'get',
        url: `ActionUrls/${id}`,
      }).then(result => result.data)
    },
    enabled: !isNullOrUndefined(id),
  })
}